import { render, staticRenderFns } from "./imprint.vue?vue&type=template&id=798b6b3e&scoped=true&"
var script = {}
import style0 from "./imprint.vue?vue&type=style&index=0&id=798b6b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798b6b3e",
  null
  
)

export default component.exports